import SettingFrame from "../../../../components/@settings/SettingFrame";
import ListInjectionFields from "../../../../components/@injection_fields/ListInjectionFields";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function InjectionFieldsPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <ListInjectionFields
                routeType={routeType}
            />
        </SettingFrame>
    )
}       